import SearchIcon from '@mui/icons-material/Search'
import LoadingButton from '@mui/lab/LoadingButton'
import { Box, TextField } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface IHeaderListFormsProps {
  searchValue: string
  handleSearchValue: (event: React.ChangeEvent<HTMLInputElement>) => void
  onSearch?: () => void
  isLoading: boolean
}

export const HeaderListUser: React.FC<IHeaderListFormsProps> = ({
  searchValue,
  handleSearchValue,
  onSearch,
  isLoading,
}) => {
  const { t } = useTranslation()

  return (
    <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'} mt={'2px'}>
      <Box display={'flex'} alignItems={'center'}>
        <TextField
          placeholder={t('user_list.keyword')}
          value={searchValue}
          onChange={handleSearchValue}
          sx={{
            '& .MuiOutlinedInput-input': {
              fontFamily: 'Roboto',
              fontStyle: 'normal',
              padding: '8px 12px',
              fontSize: 16,
              letterSpacing: 0.15,
              fontWeight: 400,
              lineHeight: '24px',
            },
            background: 'white',
            width: '220px',
          }}
          size={'small'}
        />
        <LoadingButton
          variant={'contained'}
          startIcon={<SearchIcon />}
          sx={{
            fontFamily: 'Roboto',
            ml: '8px',
            height: '40px',
            background: '#3F51B5',
            fontSize: 14,
            fontWeight: 500,
            fontStyle: 'normal',
            lineHeight: '24px',
          }}
          onClick={onSearch}
          loading={isLoading}
        >
          {t('user_list.search')}
        </LoadingButton>
      </Box>
    </Box>
  )
}
